import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FixedAmountRuleState } from './types'

export function validateFixedAmountRule(rule: FixedAmountRuleState): RuleValidation {
	if (rule.discount === null || rule.discount <= 0) {
		return { isValid: false, errors: { discount: 'invalid' } }
	}
	if (rule.threshold === null || rule.threshold <= 0) {
		return { isValid: false, errors: { threshold: 'invalid' } }
	}
	if (rule.discount >= rule.threshold) {
		return { isValid: false, errors: { discount: 'gte_threshold' } }
	}
	return { isValid: true, errors: {} }
}
